import React from 'react';

import Actions from './RowActions';

const columns = ({ enterpriseId, onDelete }) => [
  {
    title: 'Title',
    selector: 'attributes.title',
    sortable: true,
  },
  {
    name: 'Action',
    sortable: false,
    width: '150px',
    cell: (row) => <Actions row={row} onDelete={onDelete} enterpriseId={enterpriseId} />,
  },
];

export default columns;
